import React, { Component } from "react";
import { getMessage } from "CONFIG/i18n";
import { organisationAction } from "CONFIG/ActionFactory";
import "./OrganisationNavigation.less";

/**
 * Navigation component for the Super Admin Organizations section.
 * Displays a horizontal navigation bar with tabs for different organization-related views.
 * 
 * @property {Object} props - Component props
 * @property {boolean} props.usingKmsCluster - Flag to determine if Cluster Info tab should be displayed
 * @property {string} props.currentActiveTab - ID of the currently active tab
 * 
 * @method getSectionNavItems - Returns array of navigation items with conditional Cluster Info tab
 * @method handleSectionClick - Handles tab click events and updates active tab in Redux store
 * @method render - Renders the navigation bar with all available tabs
 */
class OrganisationsNavigation extends Component {
  
  getSectionNavItems = () => {
    const navItems = [
      { 
        id: '1', 
        label: getMessage('ORGANIZATIONS'), 
        icon: '🏢',
        component: 'OrganisationsList'
      },
      { 
        id: '4', 
        label: getMessage('ORGANIZATION_REPORT'), 
        icon: '📊',
        component: 'OrganisationReports'
      },
      { 
        id: '2', 
        label: getMessage('SYSTEM_ANNOUNCEMENTS'), 
        icon: '📢',
        component: 'SystemAnnouncement'
      },
    ];

    // Conditionally add Cluster Info tab if KMS cluster is being used
    if (this.props.usingKmsCluster) {
      navItems.push({ 
        id: '3', 
        label: getMessage('CLUSTER_INFO'), 
        icon: '🗄️',
        component: 'ClusterInformationList'
      });
    }

    return navItems;
  };

  /**
   * Handle tab click and save active tab to Redux store
   */
  handleSectionClick = (sectionId) => {
    organisationAction.saveCurrentActiveTab(sectionId);
  };

  render() {
    const navItems = this.getSectionNavItems();
    const { currentActiveTab } = this.props;
    
    return (
      <div className="reportsNav">
        {navItems.map(item => (
          <div
            key={item.id}
            className={`navItem ${currentActiveTab === item.id ? 'active' : ''}`}
            onClick={() => this.handleSectionClick(item.id)}
            role="button"
            tabIndex={0}
            onKeyPress={(e) => {
              if (e.key === 'Enter') this.handleSectionClick(item.id);
            }}
          >
            <span className="navIcon">{item.icon}</span>
            <span>{item.label}</span>
          </div>
        ))}
      </div>
    );
  }
}

export default OrganisationsNavigation;